import React from 'react';
import { motion } from 'framer-motion';
import { closingLines } from '../data/offer';
export function ClosingSection() {
  return <section className="bg-stage tech-grid py-16 sm:py-20" aria-labelledby="closing-title" data-id="element-47" data-mp="ounbyzutcaqa">
      <div className="mx-auto max-w-4xl px-4" data-id="element-48" data-mp="12tn26bxz4xok">
        <div className="text-center" data-id="element-49" data-mp="xtqvg4xw6s5b">
          <h2 id="closing-title" className="text-balance text-3xl font-extrabold leading-tight text-white sm:text-4xl" data-id="element-50" data-mp="xspghpdr9lib">
            Next Monday you can keep improvising…
          </h2>
          <p className="mt-4 font-display text-2xl font-extrabold text-gold sm:text-3xl" data-id="element-51" data-mp="17sq61t27wxuy">
            Or you can enter your classroom fully prepared starting today.
          </p>
        </div>

        <ul className="mx-auto mt-10 grid max-w-3xl gap-3" data-id="element-52" data-mp="1hh83q1f7aoud">
          {closingLines.map((line, index) => <motion.li key={line} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.28,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className="panel-dark flex items-center gap-3 rounded-lg border-l-4 border-gold px-4 py-3 text-sm font-semibold text-onDark" data-id="element-53" data-mp="1vgprqeko9y2o" data-mpi={index}>
              <span className="font-display text-sageGlow" aria-hidden="true" data-id="element-54" data-mp="2c98jd4y885bd">
                ▸
              </span>
              {line}
            </motion.li>)}
        </ul>

        <div className="mx-auto mt-10 max-w-2xl text-center" data-id="element-55" data-mp="2laf09f4sfi55">
          <p className="leading-relaxed text-mutedDark" data-id="element-56" data-mp="2q9roa37eav9b">
            This teacher ready won&apos;t make you a better educator. You&apos;re already an excellent educator.
          </p>
          <p className="mt-3 text-lg font-bold text-white" data-id="element-57" data-mp="3004gmhlgbsq0">
            What this teacher ready does is give you the time and tools so that excellence shows in every single class.
          </p>
        </div>
      </div>
    </section>;
}